import service from "@/store/services/inspection-form-multipliers-service";

export const state = () => ({
  list: {},
  inspectionFormMultiplier: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, inspectionFormMultiplier) => {
    state.inspectionFormMultiplier = inspectionFormMultiplier;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((inspectionFormMultiplier) => {
      commit("SET_RESOURCE", inspectionFormMultiplier);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((inspectionFormMultiplier) => {
      commit("SET_RESOURCE", inspectionFormMultiplier);
    });
  },

  update({ commit, dispatch }, params) {
    return service
      .update(params, this.$axios)
      .then((inspectionFormMultiplier) => {
        commit("SET_RESOURCE", inspectionFormMultiplier);
      });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  inspectionFormMultiplier: (state) => state.inspectionFormMultiplier,
  url: (state) => state.url,
};

const inspectionForms = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default inspectionForms;
